import React from 'react';
import JraRaceListPage from '../components/predictionService/JraRaceListPage';

// 中央競馬。運用モデルを廃止し、中央新版（穴馬モデル v15_anew）を表示する（#270）。
// 配信元は chiriri_model/csv_v14_new。サーバ側の page キーは配信スクリプト
// （run_serving_v14_new.sh）に合わせて ana_new のまま（#146）
function ChiririModelRaceList() {
  return <JraRaceListPage pageKey="ana_new" navKey="jra" pickRankOnly />;
}

export default ChiririModelRaceList;
